import { gql } from "graphql-tag"

export default gql`
  type Vendor {
    bio: String
    countryId: ID
    createdAt: String!
    id: ID!
    isPublished: Boolean!
    logoImageId: ID
    name: String!
    publishedAt: String
    slug: String!
    socialLinks: SocialLinks
    splashImageId: ID
    updatedAt: String!
  }

  input VendorAddInput {
    bio: String
    countryId: ID
    isPublished: Boolean!
    logoImageId: ID
    name: String!
    publishedAt: String
    slug: String!
    splashImageId: ID
  }

  input VendorUpdateInput {
    bio: String
    countryId: ID
    isPublished: Boolean
    logoImageId: ID
    name: String
    publishedAt: String
    slug: String
    socialLinksId: ID
    splashImageId: ID
  }

  type VendorsWave {
    cursor: String
    vendors: [Vendor]!
    hasPrevData: Boolean
    hasNextData: Boolean!
    prevCursor: String
  }

  input GetQueryVendors {
    createdAt: String
    isAscending: Boolean
    isPublished: Boolean
    limit: Int
    sortBy: String
  }

  input GetWaveQueryVendors {
    createdAt: String
    cursor: String
    isPublished: Boolean
    limit: Int
    sortBy: String
  }

  input SearchVendorsInput {
    name: String
  }
`
